"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _classnames = _interopRequireDefault(require("classnames"));
var _Multiselect = _interopRequireDefault(require("react-widgets/lib/Multiselect"));
var _cccisdApollo = require("cccisd-apollo");
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _cccisdConfirm = _interopRequireDefault(require("cccisd-confirm"));
var _cccisdFormik = require("cccisd-formik");
var _cccisdGraphqlTable = _interopRequireDefault(require("cccisd-graphql-table"));
var _arrowLeft = _interopRequireDefault(require("cccisd-icons/arrow-left7"));
var _cross = _interopRequireDefault(require("cccisd-icons/cross"));
var _eye = _interopRequireDefault(require("cccisd-icons/eye"));
var _pencil = _interopRequireDefault(require("cccisd-icons/pencil"));
var _plus = _interopRequireDefault(require("cccisd-icons/plus2"));
var _cccisdLaravelFlow = require("cccisd-laravel-flow");
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _cccisdNotification = _interopRequireDefault(require("cccisd-notification"));
var _cccisdToggle = _interopRequireDefault(require("cccisd-toggle"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _Header = _interopRequireDefault(require("../../components/Header"));
var _LackingPermissions = _interopRequireDefault(require("../../components/LackingPermissions"));
var _NoProjectsMessage = _interopRequireDefault(require("../../components/NoProjectsMessage"));
var _questPermissionsByArea = _interopRequireDefault(require("../../helpers/questPermissionsByArea.js"));
var _admin = require("../../selectors/admin.js");
var _Coding = _interopRequireDefault(require("./Coding"));
var _Disabled = _interopRequireDefault(require("./Disabled"));
var _Form = _interopRequireDefault(require("./Form.js"));
var _Formula = _interopRequireWildcard(require("./Formula"));
var _payload = _interopRequireDefault(require("./Formula/payload"));
var _InputText = _interopRequireDefault(require("./InputText"));
var _metricTypes = require("./metricTypes.js");
var _coding = _interopRequireDefault(require("./coding.graphql"));
var _variables = _interopRequireDefault(require("./variables.graphql"));
var _style = _interopRequireDefault(require("./style.css"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _getMappingValues = _interopRequireDefault(require("./getMappingValues.js"));
var _this = void 0;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var elementIcons = {};
_cccisdLaravelFlow.allElements.forEach(function (element) {
  elementIcons[element.code] = element.icon;
});
var Boilerplate = window.cccisd.boilerplate;
var Fortress = window.cccisd.fortress;
var _default = function _default(props) {
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isUpdated = _useState2[0],
    setIsUpdated = _useState2[1];
  var _useState3 = (0, _react.useState)(['quantitative', 'qualitative', 'formula', 'additional_coding']),
    _useState4 = _slicedToArray(_useState3, 2),
    metricFilter = _useState4[0],
    setMetricFilter = _useState4[1];
  var _useState5 = (0, _react.useState)([]),
    _useState6 = _slicedToArray(_useState5, 2),
    codingData = _useState6[0],
    setCodingData = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = _slicedToArray(_useState7, 2),
    loading = _useState8[0],
    setLoading = _useState8[1];
  var assignment = (0, _reactRedux.useSelector)(function (state) {
    return (0, _admin.getCurrentAssignment)(state.assignment.admin);
  });
  var surveyHandles = (0, _reactRedux.useSelector)(function (state) {
    return state.assignment.admin.currentSurveyHandles;
  });
  var currentProjectId = (0, _reactRedux.useSelector)(function (state) {
    return state.assignment.admin.currentProjectId;
  });
  var currentAssignmentId = (0, _reactRedux.useSelector)(function (state) {
    return state.assignment.admin.currentAssignmentId;
  });
  var devTagsOptions = (0, _reactRedux.useSelector)(function (state) {
    return state.assignment.admin.devTags;
  });
  var tableElement = (0, _react.useRef)(null);
  var canSeeIdentifiable = Fortress.hasAccess('quest.view_identifiable_data', currentProjectId);
  var canEditDevTags = Fortress.hasAccess('quest.dev_tags', currentProjectId);
  var fileName = assignment ? "".concat(assignment.group.group.label, " ").concat(assignment.label).replace(/[\W]+/g, '_') : '';
  var memoSetIsUpdated = function memoSetIsUpdated(value) {
    if (isUpdated !== value) {
      setIsUpdated(value);
    }
  };
  var getCodingData = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(hash, variableId) {
      var response, data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _cccisdApollo.client.query({
                query: _coding["default"],
                variables: {
                  assignmentId: [assignment.assignmentId],
                  hash: hash
                },
                fetchPolicy: 'network-only'
              });
            case 2:
              response = _context.sent;
              data = [];
              response.data.metrics.variableList.forEach(function (item) {
                if (item.tagCount > 0 && !canEditDevTags) {
                  return;
                }
                var codeItem = {
                  variableId: item.variableId,
                  variable: item.reportHeader,
                  question: item.key.title,
                  codes: Object.keys(item.mapping).map(function (key) {
                    return {
                      label: key,
                      code: item.mapping[key]
                    };
                  })
                };
                if (item.variableId === variableId) {
                  data.unshift(codeItem);
                } else {
                  data.push(codeItem);
                }
              });
              setCodingData(data);
            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function getCodingData(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
  var addAdditionalCoding = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(row) {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _cccisdAxios["default"].post(Boilerplate.route('api.metrics.variable.store'), {
                keyId: row['key.keyId'],
                reportHeader: row.reportHeader + '_0'
              });
            case 2:
              if (!metricFilter.includes('additional_coding')) {
                setMetricFilter([].concat(_toConsumableArray(metricFilter), ['additional_coding']));
              }
            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return function addAdditionalCoding(_x3) {
      return _ref2.apply(this, arguments);
    };
  }();
  var removeCoding = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(row) {
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _cccisdAxios["default"]["delete"](Boilerplate.route('api.metrics.variable.delete', {
                variable: row.variableId
              }));
            case 2:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
    return function removeCoding(_x4) {
      return _ref3.apply(this, arguments);
    };
  }();
  var updateFormula = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(values) {
      var putData, response;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              putData = (0, _payload["default"])(values);
              _context4.next = 3;
              return _cccisdAxios["default"].put(Boilerplate.route('api.metrics.formula.update', {
                formula: values.formulaId
              }), putData);
            case 3:
              response = _context4.sent;
              if (!(response.data.status === 'success')) {
                _context4.next = 10;
                break;
              }
              _context4.next = 7;
              return tableElement.current.loadData();
            case 7:
              (0, _cccisdNotification["default"])('Formula has been successfully updated');
              _context4.next = 11;
              break;
            case 10:
              return _context4.abrupt("return", Promise.reject({
                reportHeader: Object.values(response.data.errors).map(function (item) {
                  return item.join(', ');
                }).join(', ')
              }));
            case 11:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));
    return function updateFormula(_x5) {
      return _ref4.apply(this, arguments);
    };
  }();
  var deleteFormula = function deleteFormula(formulaId) {
    (0, _cccisdConfirm["default"])({
      message: 'Are you sure?',
      description: 'You are about to delete a formula'
    }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              setLoading(true);
              _context5.next = 3;
              return _cccisdAxios["default"]["delete"](Boilerplate.route('api.metrics.formula.delete', {
                formula: formulaId
              }));
            case 3:
              _context5.next = 5;
              return tableElement.current.loadData();
            case 5:
              setLoading(false);
              (0, _cccisdNotification["default"])('The formula has been successfully deleted');
            case 7:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }))).fail(function () {
      // Do nothing
    });
  };
  var downloadCsv = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return tableElement.current.downloadCsv();
            case 2:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));
    return function downloadCsv() {
      return _ref6.apply(this, arguments);
    };
  }();
  if (!assignment) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Header["default"], {
      showProjectDropdown: true,
      showQuestCount: false,
      showQuestDropdown: true,
      allowAllQuests: false,
      showSurveyDropdown: true
    }), /*#__PURE__*/_react["default"].createElement(_NoProjectsMessage["default"], null));
  }

  /* /////////////////////////////////////////////////////////////////////////
  // RENDER /////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////// */

  if (!Fortress.hasAnyAccess(_questPermissionsByArea["default"].code.permissions, currentProjectId)) {
    return /*#__PURE__*/_react["default"].createElement(_LackingPermissions["default"], null);
  }
  var tableKey = "".concat(currentAssignmentId, "-").concat(surveyHandles.join('-'));
  return /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
    loading: loading
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].table
  }, /*#__PURE__*/_react["default"].createElement(_cccisdGraphqlTable["default"], {
    key: tableKey,
    ref: tableElement,
    query: _variables["default"],
    rowKey: "variableId",
    graphqlVariables: {
      assignmentId: [assignment.assignmentId],
      surveyHandle: surveyHandles || [],
      typeFilter: metricFilter
    },
    disableNavigation: isUpdated,
    disabledNavigationMessage: "You have to save changes first",
    saveState: true,
    csvFilename: fileName + '.csv',
    noRecordsMessage: "No variables to code",
    striped: "key.entityId",
    columns: [{
      name: 'actions',
      label: '',
      rowSpanBy: 'key.entityId',
      hideInCsv: true,
      render: function render(_ref7) {
        var value = _ref7.value,
          row = _ref7.row;
        var type = row['key.entity.type'];

        // show preview only for flow elements
        if (!type || !elementIcons[type]) {
          return null;
        }
        return /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
          trigger: /*#__PURE__*/_react["default"].createElement("button", {
            type: "button",
            className: "btn btn-primary btn-xs",
            "data-preview-question": row['key.keyId']
          }, /*#__PURE__*/_react["default"].createElement(_eye["default"], null)),
          title: "Question preview"
        }, /*#__PURE__*/_react["default"].createElement(_cccisdLaravelFlow.ElementPreview, {
          entityId: row['key.entityId']
        }));
      }
    }, {
      name: 'key.title',
      label: 'Question',
      rowSpanBy: 'key.entityId',
      filter: true,
      hideInCsv: true,
      render: function render(_ref8) {
        var row = _ref8.row,
          value = _ref8.value;
        var type = row['key.entity.type'];
        return type ? /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].questionType
        }, elementIcons[type] && /*#__PURE__*/_react["default"].createElement("div", null, elementIcons[type]), /*#__PURE__*/_react["default"].createElement("div", null, type)), value) : value;
      }
    }, {
      name: 'key.title',
      label: 'Question',
      hideInTable: true
    }, {
      name: 'key.entity.type',
      label: 'Element Type',
      hideInTable: true
    }, {
      name: 'key.metric',
      label: 'Metric',
      rowSpanBy: 'key.keyId',
      filter: true
    }, {
      name: 'reportHeader',
      label: 'Variable',
      filter: true,
      className: _style["default"].minWidth,
      hideInCsv: true,
      render: function render(_ref9) {
        var value = _ref9.value,
          row = _ref9.row,
          customData = _ref9.customData;
        if (customData) {
          var initialValues = customData.initialValues,
            values = customData.values,
            errors = customData.errors;
          var isVariableUpdated = initialValues["variable".concat(row.variableId)] !== values["variable".concat(row.variableId)];
          var hasError = Boolean(errors["variable".concat(row.variableId)]);
          var disabled = row.formulaInput !== null;
          var field = /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
            "data-variable-input": row.variableId,
            name: "variable".concat(row.variableId),
            autoComplete: "off",
            component: _InputText["default"],
            disabled: disabled
          });
          var wrapper = field;
          if (disabled) {
            wrapper = /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
              title: disabled ? 'The variable is being used in at least one formula. You must remove it from any formulae in order to change the variable name' : '',
              placement: "top"
            }, field);
          }
          return /*#__PURE__*/_react["default"].createElement("div", {
            className: _style["default"].variable
          }, /*#__PURE__*/_react["default"].createElement("div", {
            className: (0, _classnames["default"])({
              'has-error': hasError,
              'has-warning': !hasError && isVariableUpdated
            })
          }, wrapper));
        }
      }
    }, {
      name: 'reportHeader',
      label: 'Variable',
      hideInTable: true
    }, {
      name: 'label',
      label: 'Label',
      filter: true,
      className: _style["default"].minWidth,
      hideInCsv: true,
      render: function render(_ref10) {
        var value = _ref10.value,
          row = _ref10.row,
          customData = _ref10.customData;
        if (customData) {
          var initialValues = customData.initialValues,
            values = customData.values;
          var isLabelUpdated = initialValues["label".concat(row.variableId)] !== values["label".concat(row.variableId)];
          return /*#__PURE__*/_react["default"].createElement("div", {
            className: (0, _classnames["default"])({
              'has-warning': isLabelUpdated
            })
          }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
            name: "label".concat(row.variableId),
            className: "form-control",
            autoComplete: "off"
          }));
        }
      }
    }, {
      name: 'label',
      label: 'Label',
      hideInTable: true
    }, {
      name: 'responseValues',
      label: 'Response Values',
      hideInCsv: true,
      render: function render(_ref11) {
        var value = _ref11.value,
          row = _ref11.row,
          loadData = _ref11.loadData,
          customData = _ref11.customData;
        /* If devTag is set, don't let someone interfere with custom
            developer work by changing the coding values */
        var isDisableEdit = !(0, _isEmpty2["default"])(row.tagList) && !canEditDevTags;
        if (row.type === 'formula') {
          if (isDisableEdit) {
            return null;
          }
          var formulaId = row['formula.formulaId'];
          if (!formulaId) {
            return null;
          }
          var isEditable = Object.prototype.hasOwnProperty.call(row, 'formula.args.isEditable') ? row['formula.args.isEditable'] : true;
          var isDeletable = Object.prototype.hasOwnProperty.call(row, 'formula.args.isDeletable') ? row['formula.args.isDeletable'] : true;
          var initialFormulaVariables = Object.keys(row).filter(function (key) {
            return key.startsWith('formula.input');
          }).map(function (key) {
            return key.slice(14);
          }).filter(function (key) {
            return key.length > 0;
          });
          return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, isEditable && /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
            trigger: /*#__PURE__*/_react["default"].createElement("button", {
              type: "button",
              className: "btn btn-primary btn-xs",
              style: {
                marginRight: '0.3em'
              }
            }, /*#__PURE__*/_react["default"].createElement(_pencil["default"], null)),
            title: "Edit formula",
            size: "large"
          }, /*#__PURE__*/_react["default"].createElement(_Formula["default"], {
            onSubmit: updateFormula,
            updatingVariableId: row.variableId,
            initialValues: {
              formulaId: formulaId,
              reportHeader: row.reportHeader,
              label: row.label,
              type: row['formula.type'],
              variables: row['formula.type'] === _Formula.IF_THEN ? [] : initialFormulaVariables,
              calculateCondition: row['formula.args.n_input'] === initialFormulaVariables.length ? 'all' : 'minimum',
              minimumAnswers: row['formula.args.n_input'] === initialFormulaVariables.length ? 1 : row['formula.args.n_input'],
              minimum: row['formula.args.minimum'],
              maximum: row['formula.args.maximum'],
              ifThen: {
                conditions: row['formula.args.conditions'] || [{
                  key: 1,
                  condition: _Formula.initialCondition
                }],
                otherwise: row['formula.args.otherwise'] || '',
                nextKey: row['formula.args.nextKey'] || 2
              }
            },
            isUpdating: true
          })), isDeletable && /*#__PURE__*/_react["default"].createElement("button", {
            type: "button",
            className: "btn btn-danger btn-xs",
            onClick: deleteFormula.bind(_this, formulaId)
          }, /*#__PURE__*/_react["default"].createElement(_cross["default"], null)));
        }
        if (!row.isCodable) {
          return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, row['key.content.minimum'] && /*#__PURE__*/_react["default"].createElement("div", null, "Min: ", row['key.content.minimum']), row['key.content.maximum'] && /*#__PURE__*/_react["default"].createElement("div", null, "Max: ", row['key.content.maximum']));
        }
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].coding
        }, /*#__PURE__*/_react["default"].createElement("div", null, row.isCodable && (0, _getMappingValues["default"])(row).map(function (item) {
          return /*#__PURE__*/_react["default"].createElement("div", {
            key: item.label,
            className: _style["default"].codes,
            title: item.label
          }, item.code !== item.label && /*#__PURE__*/_react["default"].createElement("span", null, item.code, /*#__PURE__*/_react["default"].createElement(_arrowLeft["default"], {
            spaceRight: true,
            spaceLeft: true
          })), item.label);
        })), row.isCodable && customData && /*#__PURE__*/_react["default"].createElement("div", null, !isDisableEdit && /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
          trigger: /*#__PURE__*/_react["default"].createElement("button", {
            type: "button",
            className: "btn btn-primary btn-xs",
            "data-edit-coding": row.variableId
          }, /*#__PURE__*/_react["default"].createElement(_pencil["default"], null)),
          title: "Coding",
          size: "calc(100vw - 2em)",
          beforeShow: getCodingData.bind(null, row['key.enumMd5'], row.variableId)
        }, /*#__PURE__*/_react["default"].createElement(_Coding["default"], {
          variableId: row.variableId,
          data: codingData,
          loadData: loadData,
          actualValues: customData && customData.values
        })), !isDisableEdit && row.type === 'additional_coding' && /*#__PURE__*/_react["default"].createElement(_Disabled["default"], {
          disabled: isUpdated
        }, /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            marginTop: '0.3em'
          }
        }, /*#__PURE__*/_react["default"].createElement("button", {
          type: "button",
          className: "btn btn-danger btn-xs",
          "data-remove-additional-coding": row.variableId,
          onClick: /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
            return _regeneratorRuntime().wrap(function _callee7$(_context7) {
              while (1) {
                switch (_context7.prev = _context7.next) {
                  case 0:
                    setLoading(true);
                    _context7.next = 3;
                    return removeCoding(row);
                  case 3:
                    _context7.next = 5;
                    return loadData();
                  case 5:
                    setLoading(false);
                  case 6:
                  case "end":
                    return _context7.stop();
                }
              }
            }, _callee7);
          }))
        }, /*#__PURE__*/_react["default"].createElement(_cross["default"], null)))), row.type === 'quantitative' && !row.hasAdditionalCoding && /*#__PURE__*/_react["default"].createElement(_Disabled["default"], {
          disabled: isUpdated
        }, /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            marginTop: '0.3em'
          }
        }, /*#__PURE__*/_react["default"].createElement("button", {
          type: "button",
          className: "btn btn-primary btn-xs",
          "data-add-additional-coding": row.variableId,
          onClick: /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
            return _regeneratorRuntime().wrap(function _callee8$(_context8) {
              while (1) {
                switch (_context8.prev = _context8.next) {
                  case 0:
                    setLoading(true);
                    _context8.next = 3;
                    return addAdditionalCoding(row);
                  case 3:
                    _context8.next = 5;
                    return loadData();
                  case 5:
                    setLoading(false);
                  case 6:
                  case "end":
                    return _context8.stop();
                }
              }
            }, _callee8);
          }))
        }, /*#__PURE__*/_react["default"].createElement(_plus["default"], null))))));
      }
    }, {
      name: 'responseValues',
      label: 'Response Values',
      hideInTable: true,
      render: function render(_ref14) {
        var value = _ref14.value,
          row = _ref14.row,
          loadData = _ref14.loadData,
          customData = _ref14.customData;
        if (row.type === 'formula') {
          return null;
        }
        if (!row.isCodable) {
          return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, row['key.content.minimum'] && "Min: ".concat(row['key.content.minimum'], "\n"), row['key.content.maximum'] && "Max: ".concat(row['key.content.maximum']));
        }
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].coding
        }, /*#__PURE__*/_react["default"].createElement("div", null, row.isCodable && (0, _getMappingValues["default"])(row).map(function (item) {
          return /*#__PURE__*/_react["default"].createElement("div", {
            key: item.label,
            className: _style["default"].codes,
            title: item.label
          }, item.code !== item.label && "".concat(item.code, " - "), "".concat(item.label, "\n"));
        })));
      }
    }, {
      name: 'type',
      label: 'Metric Type',
      render: function render(_ref15) {
        var value = _ref15.value;
        return _metricTypes.metricTypesMap[value] || '';
      }
    }, {
      name: 'key.isIdentifying',
      label: 'Identifiable',
      hideInCsv: true,
      render: function render(_ref16) {
        var value = _ref16.value,
          row = _ref16.row,
          customData = _ref16.customData;
        var identifiable = canSeeIdentifiable ? /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
          name: "isIdentifying".concat(row.variableId),
          component: _cccisdFormik.CccisdToggle
        }) : /*#__PURE__*/_react["default"].createElement(_cccisdToggle["default"], {
          value: row['key.isIdentifying'],
          disabled: true
        });
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].center
        }, identifiable);
      },
      rowSpanBy: 'key.keyId'
    }, {
      name: 'key.isIdentifying',
      label: 'Identifiable',
      hideInTable: true
    }, {
      name: 'key.flow.language',
      label: 'Language',
      rowSpanBy: 'key.entityId',
      filter: true,
      hideInCsv: true,
      render: function render(_ref17) {
        var value = _ref17.value,
          row = _ref17.row,
          customData = _ref17.customData;
        var surveysInList = [];
        var _iterator = _createForOfIteratorHelper(row['key.surveyList']),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var surveyList = _step.value;
            var test = surveyList.label;
            if (!surveysInList.includes(test)) {
              surveysInList.push(test);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        return /*#__PURE__*/_react["default"].createElement("div", null, surveysInList.join('<br />'), /*#__PURE__*/_react["default"].createElement("br", null), row['key.flow.language']);
      }
    }, {
      name: 'key.surveyList',
      label: 'Survey',
      hideInTable: true,
      render: function render(_ref18) {
        var value = _ref18.value,
          row = _ref18.row,
          customData = _ref18.customData;
        var surveysInList = [];
        var _iterator2 = _createForOfIteratorHelper(row['key.surveyList']),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var surveyList = _step2.value;
            var test = surveyList.label;
            if (!surveysInList.includes(test)) {
              surveysInList.push(test);
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
        return /*#__PURE__*/_react["default"].createElement("div", null, surveysInList.map(function (item) {
          return "".concat(item, " - ").concat(row['key.flow.language'], "\n");
        }));
      }
    }].concat(_toConsumableArray(canEditDevTags ? [{
      name: 'devTags',
      label: 'Dev tags',
      className: _style["default"].devTags,
      hideInCsv: true,
      render: function render(_ref19) {
        var value = _ref19.value,
          row = _ref19.row,
          customData = _ref19.customData;
        return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
          name: "devTags".concat(row.variableId)
        }, function (_ref20) {
          var field = _ref20.field,
            form = _ref20.form;
          return /*#__PURE__*/_react["default"].createElement(_Multiselect["default"], {
            data: devTagsOptions,
            value: field.value,
            onChange: function onChange(values) {
              form.setFieldValue(field.name, values);
            }
          });
        });
      }
    }, {
      name: 'devTags',
      label: 'Dev tags',
      className: _style["default"].devTags,
      hideInTable: true,
      render: function render(_ref21) {
        var value = _ref21.value,
          row = _ref21.row,
          customData = _ref21.customData;
        var tagList = row.tagList;
        if (!(0, _isEmpty2["default"])(tagList)) {
          return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, tagList.map(function (item) {
            return "".concat(item.name, "\n");
          }));
        }
        return null;
      }
    }] : [])),
    render: function render(args) {
      return /*#__PURE__*/_react["default"].createElement(_Form["default"], _extends({}, args, {
        downloadCsv: downloadCsv,
        setIsUpdated: memoSetIsUpdated,
        metricFilter: metricFilter,
        setMetricFilter: setMetricFilter,
        assignment: assignment,
        surveyHandles: surveyHandles,
        elementIcons: elementIcons
      }));
    }
  })));
};
exports["default"] = _default;